import { useStytchMember } from '@stytch/react/b2b'
import { useCurrentAccountContext } from '@/components/accounts/CurrentAccountProvider'

export default function useIsInCurrentAccount() {
  const { currentAccount } = useCurrentAccountContext()
  const { member } = useStytchMember()
  return member?.organization_id === currentAccount.stytch_org_id
}
